export default class ValidateOnlyNumbers {
   errMsg;
   pattern = /^\d+(?:\.\d+)?(?!\.)$/;
   isFloat = false;
   allowNegativeValue = false;

   constructor(isFloat, allowNegativeValue) {
      if (isFloat === true) {
         this.isFloat = true;
         this.pattern = /^(([0-9]+)?\.[0-9]+)$/;
      }

      if (allowNegativeValue === true) {
         this.allowNegativeValue = true;

         if (this.isFloat) this.pattern = /^(-?([0-9]+)?\.[0-9]+)$/;
         else this.pattern = /^-?\d+(?:\.\d+)?(?!\.)$/;
      }
   }

   validate(value) {
      if (!this.pattern.test(value.toString()) && value != '') return this.setErr();
      else return true;
   }

   setErr() {
      if (this.isFloat) this.errMsg = ['lang_only_float_numbers'];
      else this.errMsg = ['lang_only_numbers'];

      return this.errMsg;
   }
}